<template>
  <div>
    <Paginacao
      v-if="monitoria && !!conteudo"
      :conteudo="Object.entries(conteudo)"
      @pagina="p => (produtosPaginados = p)"
    >
      <TabelaProdutoMonitoria
        v-if="!!produtosPaginados"
        :produtosPaginados="produtosPaginados"
        @atualizaProdutos="emitListarProdutos"
        @ordenar="ordenarMonitoria"
        @editarProduto="editarProdutoMonitoria"
      />
      <div class="loading-produto-monitoria">
        <font-awesome-icon v-if="blBigData" class="loading-icon" icon="spinner" spin />
      </div>
    </Paginacao>
    <Paginacao v-else :conteudo="conteudo" @pagina="p => (produtosPaginados = p)" produtos>
      <Tabela
        :colunas="colunas"
        @emitOrdenar="recebeOrdenar"
        :conteudo="produtosPaginados"
        :expandir="'observacao'"
      ></Tabela>
    </Paginacao>
  </div>
</template>

<script>
import Tabela from "@/components/Tabela/Tabela.vue";
import Paginacao from "@/components/Paginacao/Paginacao.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import TabelaProdutoMonitoria from "../Tabela/TabelaProdutoMonitoria.vue";

export default {
  name: "TabelaPaginada",
  props: {
    conteudo: {
      type: [Object, Array], // Aceita tanto objeto como array
      required: true
    },
    monitoria: Boolean,
    blBigData: Boolean
  },
  components: {
    Tabela,
    Paginacao,
    TabelaProdutoMonitoria
  },

  data() {
    return {
      colunas: [
        { titulo: "ALTERAÇÃO", valor: "data_alteracao" },
        { titulo: "NCM/NBM", valor: "ncm_produto" },
        { titulo: "CEST", valor: "cest" },
        { titulo: "TIPO", valor: "tipo_tributacao" },
        { titulo: "UF", valor: "estado_mudanca" },
        { titulo: "DESCRIÇÃO", valor: "descricao" },
        { titulo: "EFEITO", valor: "data_efeito" }
      ],
      produtosPaginados: null,
      strOrdem: ""
    };
  },
  mounted() {},
  computed: {
    ...mapGetters("empresa", {
      getEmpresa: "getEmpresa"
    })
  },

  methods: {
    recebeOrdenar(strOrdem) {
      this.ordenar(strOrdem);
    },
    emitListarProdutos() {
      this.$emit("atualizaProdutos");
    },
    converterData(data) {
      // Separa a data em dia, mês e ano
      if (data && data != "" && data != "-") {
        const [dia, mes, ano] = data.split("/");

        // Retorna a data no formato "mm/dd/yyyy"
        return Date.parse(`${mes} ${dia} ${ano}`);
      } else {
        return 0;
      }
    },
    editarProdutoMonitoria(prod) {
      this.$emit("editarProduto", prod);
    },
    ordenarMonitoria(strOrdem) {
      this.$emit("ordenar", strOrdem);
    },
    ordenar: function(strOrdem) {
      if (strOrdem == this.strOrdem) {
        this.reverse = !this.reverse;
        this.conteudo.reverse();
        return;
      }
      this.reverse = false;
      if (strOrdem == "data_alteracao" || strOrdem == "data_efeito") {
        this.conteudo.sort((a, b) => {
          if (a[strOrdem] == null) {
            return;
          }

          var dataA = this.converterData(a[strOrdem]).toString();
          var dataB = this.converterData(b[strOrdem]).toString();
          return dataA.localeCompare(dataB);
        });
      } else {
        this.conteudo.sort((a, b) => {
          if (a[strOrdem] == null) {
            return;
          }
          if (
            a[strOrdem] == "-" ||
            a[strOrdem] == "" ||
            a[strOrdem] == "0" ||
            b[strOrdem] == "-" ||
            b[strOrdem] == "" ||
            b[strOrdem] == "0"
          ) {
            return a[strOrdem] == "-" || a[strOrdem] == "" || a[strOrdem] == "0" ? 1 : -1;
          }
          return a[strOrdem].localeCompare(b[strOrdem]);
        });
      }
      this.strOrdem = strOrdem;
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-produto-monitoria {
  font-size: 20px;
  margin: 10px;
  text-align: center;
}
</style>
